import { Breakpoint } from '@mui/material/styles';
import useBreakpoint from '../../../lib/useBreakpoint';
import compareBreakpoints from '../utils/compareBreakpoints';

interface UseBreakpointStatusProps {
  /**
   * @description The breakpoint at which the component should be rendered.
   */
  breakpointToCover: Breakpoint;
}

type UseBreakpointStatusReturn = null | {
  /**
   * @description the result of a breakpoint comparison. 1 if greater, 0 if meets, -1 if lesser
   */
  comparison: -1 | 0 | 1;
  /**
   * Boolean for the condition if the current breakpoint is below the given breakpoint
   */
  isBelowBreakpoint: boolean;
  /**
   * Boolean for the condition if the current breakpoint is at the given breakpoint
   */
  isAtBreakpoint: boolean;
  /**
   * Boolean for the condition if the current breakpoint is above the given breakpoint
   */
  isAboveBreakpoint: boolean;
};

/**
 * @description A hook that returns a modal component to cover the screen
 *              when the screen has reached a certain breakpoint. Returns null if unavailable.
 */
export default function useBreakpointStatus({
  breakpointToCover,
}: UseBreakpointStatusProps): UseBreakpointStatusReturn {
  const currentBreakpoint = useBreakpoint();
  if (!currentBreakpoint) return null;

  const result = compareBreakpoints(currentBreakpoint, breakpointToCover);

  return {
    comparison: result,
    isBelowBreakpoint: result === -1,
    isAtBreakpoint: result === 0,
    isAboveBreakpoint: result === 1,
  };
}
